// frontend/src/components/admin/AdminStats.js
import React from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";
import {
  PeopleAlt,
  AccountBalance,
  SwapHoriz,
  SimCard,
} from "@mui/icons-material";

const StatCard = ({ title, value, icon: Icon, color }) => (
  <Paper sx={{ p: 2 }}>
    <Box display="flex" alignItems="center">
      <Box
        sx={{
          bgcolor: `${color}.light`,
          p: 1.5,
          borderRadius: 2,
          mr: 2,
        }}
      >
        <Icon sx={{ color: `${color}.main` }} />
      </Box>
      <Box>
        <Typography variant="h6" component="div">
          {value.toLocaleString()}
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {title}
        </Typography>
      </Box>
    </Box>
  </Paper>
);

const AdminStats = ({ stats }) => {
  const statItems = [
    {
      title: "Total Resellers",
      value: stats.totalResellers,
      icon: PeopleAlt,
      color: "primary",
    },
    {
      title: "Total Credits Issued",
      value: stats.totalCreditsIssued,
      icon: AccountBalance,
      color: "success",
    },
    {
      title: "Total Transactions",
      value: stats.totalTransactions,
      icon: SwapHoriz,
      color: "info",
    },
    {
      title: "Total eSIM Orders",
      value: stats.totalESIMOrders,
      icon: SimCard,
      color: "warning",
    },
  ];

  return (
    <Grid container spacing={3}>
      {statItems.map((item) => (
        <Grid item xs={12} sm={6} md={3} key={item.title}>
          <StatCard {...item} />
        </Grid>
      ))}
    </Grid>
  );
};

export default AdminStats;
